// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileOutlinedSvg from "@fishx/icons-svg/es/asn/ProfileOutlined";
import FishxIcon from '../components/FishxIcon';

var ProfileOutlined = function ProfileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProfileOutlinedSvg
  }));
};

ProfileOutlined.displayName = 'ProfileOutlined';
export default React.forwardRef(ProfileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProfileOutlined.js
// module id = 3852
// module chunks = 0